const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || "http://localhost:8000",
  RAZORPAY_KEY_ID: process.env.REACT_APP_RAZORPAY_KEY_ID || "",
  API_VERSION: "/app/v1",
  ENDPOINTS: {
    AUTH: "/app/v1/user/auth",
    PROFILE: "/app/v1/user/profile",
    PUBLIC: "/app/v1/user/public",
    BOOKING: "/app/v1/user/booking",
    PAYMENT: "/app/v1/user/payment",
  },
  TOKEN_STORAGE_KEY: "fusioncab_access_token",
  REFRESH_TOKEN_STORAGE_KEY: "fusioncab_refresh_token",
  USER_STORAGE_KEY: "fusioncab_user",
  
};

export default config;
